import { toast } from "react-toastify";
import fileIcom from "../assets/img/icons/file.png";

export const handleShowPassword = (setShow, show, type) => {
  if (type) {
    return setShow({ ...show, [type]: !show[type] })
  }
  return setShow(!show);
};


export const getImageUrl  = (url = "") => {
  const fileType = url?.split(".")[url.split(".")?.length - 1];
  return ['png', 'jpg', 'jpeg', 'tiff', 'webp'].indexOf(fileType) > -1 ? url : fileIcom;
}

export const isImage  = (url = "") => {
  const fileType = url?.split(".")[url.split(".")?.length - 1];
  return ['png', 'jpg', 'jpeg', 'tiff', 'webp'].indexOf(fileType?.toLocaleLowerCase()) > -1 ? true : false;
}

export const supportedFileExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'tiff'];
export const validateEmail = (mail) => {
  const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g); // eslint-disable-line
  return regex.test(String(mail).toLowerCase());
};

export const validatePhoneNumber = (phoneNo) => {
  return phoneNo.replace(new RegExp(/[^\d]/, "ig"), "");
};

export const getClassName = (data, field) => {
  return data[field] ? "" : "hidden";
};

export const genericError = (error) => {
  toast.error(
    error?.mesaage || error.message || "Something went wrong, Please try again after sometime"
  );
};

export const rateMsg = () => {
  return (
    <>
      <p style={{textAlign: 'center'}}><strong>NOTE</strong></p>
      <p>
        Author has the opportunity to choose <br/> from various vendors. Please ensure <br/>that your rates are true to market.
      </p>
    </>
  )
}
// Not able to Publish Profile? Please ensure that you have filled all the mandatory sections. Try again
export const unPublishToolTip = "Please save the data before the Publishing the profile.";
export const tooltipMsg = () => {
  return (
    <ul>
      <h4 className="text-center">PASSWORD CRITERIA</h4>
      <li>At least 8 characters —the more characters, the better.</li>
      <li>A mixture of both uppercase and lowercase letters.</li>
      <li>A mixture of letters and numbers.</li>
      <li>Inclusion of at least one special character, e.g., ! @ # ? ]</li>
    </ul>
  )
}

export const handleChatBot = (e) => {
  e.preventDefault();
  window.zE('messenger', 'open');
}

export const statusObj = {
  "pending": "Pending",
  "approved": "Approved",
  "reject": "Rejected"
}

export const  removeDuplicates = (arr = []) => {
  return arr.filter((item, 
      index) => arr.indexOf(item) === index);
}

export const ratesTooltip = (level = 1 ) => {
  return (
      <>
        <p style={{textAlign: 'center'}} className="mb-2"><strong>Level {level} is defined as:</strong></p>
        <ul>
          <li>Fixing of grammatical errors.</li>
          <li>No rewriting of sentences.</li>
          <li>Level {level}  is from <strong>{level > 1 ? "INR 150 - INR 300." : "INR 100 - INR 200."}</strong></li>
        </ul>
        {/* <ul className="liststyle-none">
          {level == 1 ? <li>1. Copywriting Level 1 from Rs 100 - Rs 200.</li> : <li>1. Copy editing Level 2 from Rs 150 - Rs 300.</li>}
        </ul>
        <ol className="liststyle-none">
          {level == 1 ? <li>**Level 1: Defined as fixing of grammatical errors. No rewriting of sentences</li> : <li>***Level 2: will include all of level 1 and up to 20% of content rewritten.</li>}
        </ol> */}
      </>
  )
}

export const panCardTooltip = () => {
  return (
    <>
      <p>This PAN Card image is private to you.</p>
      <p>It will not be visible to anyone else on the platform.</p>
    </>
  )
}


export const checkUrl = (url) => {
  const regexforhttp = new RegExp(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/)
  // const regex =new RegExp(/(ftp|http|https):\/\/?www\.(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/)

  const regex =new RegExp(/^((ftp|http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/)
  // const regex =new RegExp(/(?:http[s]?\/\/)?(?:[\w\-]+(?::[\w\-]+)?@)?(?:[\w\-]+\.)+(?:[a-z]{2,4})(?::[0-9]+)?(?:\/[\w\-\.%]+)*(?:\?(?:[\w\-\.%]+=[\w\-\.%!]+&?)+)?(#\w+\-\.%!)?/)

  return regex.test(url) && regexforhttp.test(url)
}

export const ProfessionalUrlCheck = (url) => {
  const regex =new RegExp(/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi)

  return regex.test(url)
}


const mandatoryFields = ['email', 'phoneNumber', 'fullName']
export const isPublishable = (data) => {
  var publish = true;
  for (let i = 0; i < mandatoryFields.length - 1; i++) {
    if (!publish) { break; }
    publish = data[mandatoryFields[i]] ? true : false
  }
  if(publish) {
    if(!data.profilePicture && !data?.aboutId?.profilePicture ) {
      publish = false
    }

    if(data.serviceId && data.serviceId.length < 1) {
      publish = false;
    }
  }
  return publish
}